module.exports = __webpack_public_path__ + "fonts/GothamPro-Bold.093acec8.woff";